export default __webpack_public_path__ + "static/media/vic_2.19f4a203.png";